import classNames from 'classnames';
import { FC, HTMLProps, ReactNode, useEffect } from 'react';
import { useLocation } from 'react-router';
import { useBoolean } from 'react-easyrocket';
import { ScrollToTopButton } from '../ScrollToTopButton/ScrollToTopButton';
import { useWindowSize } from 'src/modules/store/windowSizeStore';
import { Navbar } from '../Navbar';

interface FullScreenContainerProps extends HTMLProps<HTMLDivElement> {
  children: ReactNode;
  additionalClassName?: string;
}

export const FullScreenContainer: FC<FullScreenContainerProps> = ({
  children,
  additionalClassName,
  ...rest
}) => {
  const [buttonVisible, showButton, hideButton] = useBoolean();
  const { pathname } = useLocation();
  const { isMobileLayout } = useWindowSize('isMobileLayout');

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [pathname]);

  useEffect(() => {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 500) {
        showButton();
      } else {
        hideButton();
      }
    });
  }, [hideButton, showButton]);

  const handleScrollTo = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div
      className={classNames(
        'w-full min-h-screen flex flex-col justify-start items-center',
        additionalClassName
      )}
      {...rest}>
      <ScrollToTopButton onClick={handleScrollTo} visible={buttonVisible} />
      {children}
      {isMobileLayout && (
        <div className="fixed bottom-0 w-full z-[500]">
          <Navbar />
        </div>
      )}
    </div>
  );
};
